<template>
  <div class="my-4">
    <v-text-field light label="Title" v-model="item.title" type="text" required color="amber" placeholder="Name"
      class="my-10"></v-text-field>
    <v-textarea light label="Sub title" v-model="item.sentence" type="text" required color="amber" :rows="2"
      placeholder="Name" class="my-10" :autoGrow="true" :hide-details="true"></v-textarea>

    <v-textarea light label="Description" color="amber" v-model.trim="item.body" :rows="2" :autoGrow="true"
      :hide-details="true" />

    <v-select :items="local.categories" label="Categories" multiple v-model.trim="item.categories" light></v-select>

    <div class="d-flex justify-end align-center pr-3">
      <v-btn @click="submit" small color="amber" class="my-4" light>Change</v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "RollOutColForm",
  props: {
    newItem: {
      type: Object,
      default: () => { },
    },
    colors: {
      type: Array,
      default: () => [],
    },
    local: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      item: this.newItem,
    };
  },
  methods: {
    submit() {
      this.$emit("update", this.item);
      this.$set(this.item, {});
    },
  },
};
</script>
